"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaPlaybackContextProvider = exports.Player = exports.EditableText = exports.Avatar = exports.SafeAreaView = exports.useResizeObserver = exports.TruncatedText = exports.ScrollableContainer = exports.Div = exports.A = exports.PortalHost = exports.Portal = exports.useColorScheme = exports.PageSection = exports.ClickableContainer = exports.InputNumber = exports.Input = exports.Checkbox = exports.CollapseRoot = exports.Collapse = exports.LoadingIndicator = exports.Reset = exports.formatTime = exports.abbreviatePlural = exports.NUMBER_FORMATS = exports.DATE_FORMATS = exports.MiddotDelimitedList = exports.Popconfirm = exports.Modal = exports.Button = exports.AntIconWrapper = exports.Tooltip = exports.message = exports.Dropdown = exports.Image = exports.NotFound = exports.Empty = exports.VSpaced = exports.Space = exports.HSpaced = exports.Block = exports.mergePermissions = exports.PermissionOverlay = exports.PermissionMode = exports.usePrompt = exports.AntForm = exports.Markdown = exports.Result = exports.GridContainer = exports.Grid = void 0;
exports.MultiFilterButton = exports.FilterButton = exports.useEffectAfterMount = exports.useUpdatingState = exports.useUpdatingRef = exports.HlsPlayer = exports.AntiIcon = exports.omitDeep = exports.MediaPlaybackContext = exports.useMediaPlaybackContext = void 0;
exports.Grid = __importStar(require("./grid"));

__exportStar(require("./types"), exports);

__exportStar(require("./files"), exports);

__exportStar(require("./typography"), exports);

__exportStar(require("./theme"), exports);

__exportStar(require("./navigation"), exports);

__exportStar(require("./styled"), exports);

__exportStar(require("./isNative"), exports);

__exportStar(require("./storage/flags"), exports);

__exportStar(require("./storage/storage"), exports);

__exportStar(require("./responsive"), exports);

__exportStar(require("./styled/ThemeProvider"), exports);

__exportStar(require("./styled/Blur"), exports);

__exportStar(require("./form"), exports);

__exportStar(require("./styled/List"), exports);

__exportStar(require("./styled/ErrorIndicator"), exports);

__exportStar(require("./styled/Skeleton"), exports);

__exportStar(require("./styled/SelectableButton"), exports);

__exportStar(require("./ModalNavigationItem"), exports);

__exportStar(require("./dom/ScrollableContainerContext"), exports);

__exportStar(require("./dom/isHtmlElement"), exports);

var Grid_1 = require("./styled/Grid");

Object.defineProperty(exports, "GridContainer", {
  enumerable: true,
  get: function get() {
    return Grid_1.Grid;
  }
});

__exportStar(require("./useDebounce"), exports);

var Result_1 = require("./ant/Result");

Object.defineProperty(exports, "Result", {
  enumerable: true,
  get: function get() {
    return Result_1.Result;
  }
});

var Markdown_1 = require("./dom/Markdown");

Object.defineProperty(exports, "Markdown", {
  enumerable: true,
  get: function get() {
    return Markdown_1.Markdown;
  }
});

var Form_1 = require("./ant/Form");

Object.defineProperty(exports, "AntForm", {
  enumerable: true,
  get: function get() {
    return Form_1.Form;
  }
});

var usePrompt_1 = require("./usePrompt");

Object.defineProperty(exports, "usePrompt", {
  enumerable: true,
  get: function get() {
    return usePrompt_1.usePrompt;
  }
});

var PermissionOverlay_1 = require("./PermissionOverlay");

Object.defineProperty(exports, "PermissionMode", {
  enumerable: true,
  get: function get() {
    return PermissionOverlay_1.PermissionMode;
  }
});
Object.defineProperty(exports, "PermissionOverlay", {
  enumerable: true,
  get: function get() {
    return PermissionOverlay_1.PermissionOverlay;
  }
});
Object.defineProperty(exports, "mergePermissions", {
  enumerable: true,
  get: function get() {
    return PermissionOverlay_1.mergePermissions;
  }
});

var Block_1 = require("./styled/Block");

Object.defineProperty(exports, "Block", {
  enumerable: true,
  get: function get() {
    return Block_1.Block;
  }
});
Object.defineProperty(exports, "HSpaced", {
  enumerable: true,
  get: function get() {
    return Block_1.HSpaced;
  }
});
Object.defineProperty(exports, "Space", {
  enumerable: true,
  get: function get() {
    return Block_1.Space;
  }
});
Object.defineProperty(exports, "VSpaced", {
  enumerable: true,
  get: function get() {
    return Block_1.VSpaced;
  }
});

var Empty_1 = require("./ant/Empty");

Object.defineProperty(exports, "Empty", {
  enumerable: true,
  get: function get() {
    return Empty_1.Empty;
  }
});
Object.defineProperty(exports, "NotFound", {
  enumerable: true,
  get: function get() {
    return Empty_1.NotFound;
  }
});

var Image_1 = require("./ant/Image");

Object.defineProperty(exports, "Image", {
  enumerable: true,
  get: function get() {
    return Image_1.Image;
  }
});

var Dropdown_1 = require("./ant/Dropdown");

Object.defineProperty(exports, "Dropdown", {
  enumerable: true,
  get: function get() {
    return Dropdown_1.Dropdown;
  }
});

var message_1 = require("./ant/message");

Object.defineProperty(exports, "message", {
  enumerable: true,
  get: function get() {
    return message_1.message;
  }
});

var Tooltip_1 = require("./ant/Tooltip");

Object.defineProperty(exports, "Tooltip", {
  enumerable: true,
  get: function get() {
    return Tooltip_1.Tooltip;
  }
});

var AntIconWrapper_1 = require("./ant/AntIconWrapper");

Object.defineProperty(exports, "AntIconWrapper", {
  enumerable: true,
  get: function get() {
    return AntIconWrapper_1.AntIconWrapper;
  }
});

var Button_1 = require("./ant/Button");

Object.defineProperty(exports, "Button", {
  enumerable: true,
  get: function get() {
    return Button_1.Button;
  }
});

var Modal_1 = require("./ant/Modal");

Object.defineProperty(exports, "Modal", {
  enumerable: true,
  get: function get() {
    return Modal_1.Modal;
  }
});

var Popconfirm_1 = require("./ant/Popconfirm");

Object.defineProperty(exports, "Popconfirm", {
  enumerable: true,
  get: function get() {
    return Popconfirm_1.Popconfirm;
  }
});

var MiddotDelimitedList_1 = require("./ant/MiddotDelimitedList");

Object.defineProperty(exports, "MiddotDelimitedList", {
  enumerable: true,
  get: function get() {
    return MiddotDelimitedList_1.MiddotDelimitedList;
  }
});

var constants_1 = require("@thesisedu/web/dist/constants");

Object.defineProperty(exports, "DATE_FORMATS", {
  enumerable: true,
  get: function get() {
    return constants_1.DATE_FORMATS;
  }
});
Object.defineProperty(exports, "NUMBER_FORMATS", {
  enumerable: true,
  get: function get() {
    return constants_1.NUMBER_FORMATS;
  }
});
Object.defineProperty(exports, "abbreviatePlural", {
  enumerable: true,
  get: function get() {
    return constants_1.abbreviatePlural;
  }
});

var time_1 = require("@thesisedu/web/dist/time");

Object.defineProperty(exports, "formatTime", {
  enumerable: true,
  get: function get() {
    return time_1.formatTime;
  }
});

var Reset_1 = require("./Reset");

Object.defineProperty(exports, "Reset", {
  enumerable: true,
  get: function get() {
    return Reset_1.Reset;
  }
});

var LoadingIndicator_1 = require("./ant/LoadingIndicator");

Object.defineProperty(exports, "LoadingIndicator", {
  enumerable: true,
  get: function get() {
    return LoadingIndicator_1.LoadingIndicator;
  }
});

var CollapsePanel_1 = require("./ant/CollapsePanel");

Object.defineProperty(exports, "Collapse", {
  enumerable: true,
  get: function get() {
    return CollapsePanel_1.Collapse;
  }
});

var Collapse_1 = require("./ant/Collapse");

Object.defineProperty(exports, "CollapseRoot", {
  enumerable: true,
  get: function get() {
    return Collapse_1.CollapseRoot;
  }
});

var Checkbox_1 = require("./ant/Checkbox");

Object.defineProperty(exports, "Checkbox", {
  enumerable: true,
  get: function get() {
    return Checkbox_1.Checkbox;
  }
});

var Input_1 = require("./ant/Input");

Object.defineProperty(exports, "Input", {
  enumerable: true,
  get: function get() {
    return Input_1.Input;
  }
});

var InputNumber_1 = require("./ant/InputNumber");

Object.defineProperty(exports, "InputNumber", {
  enumerable: true,
  get: function get() {
    return InputNumber_1.InputNumber;
  }
});

var ClickableContainer_1 = require("./dom/ClickableContainer");

Object.defineProperty(exports, "ClickableContainer", {
  enumerable: true,
  get: function get() {
    return ClickableContainer_1.ClickableContainer;
  }
});

var PageSection_1 = require("./dom/PageSection");

Object.defineProperty(exports, "PageSection", {
  enumerable: true,
  get: function get() {
    return PageSection_1.PageSection;
  }
});

var useColorScheme_1 = require("./dom/useColorScheme");

Object.defineProperty(exports, "useColorScheme", {
  enumerable: true,
  get: function get() {
    return useColorScheme_1.useColorScheme;
  }
});

var Portal_1 = require("./dom/Portal");

Object.defineProperty(exports, "Portal", {
  enumerable: true,
  get: function get() {
    return Portal_1.Portal;
  }
});
Object.defineProperty(exports, "PortalHost", {
  enumerable: true,
  get: function get() {
    return Portal_1.PortalHost;
  }
});

var A_1 = require("./dom/A");

Object.defineProperty(exports, "A", {
  enumerable: true,
  get: function get() {
    return A_1.A;
  }
});

var Div_1 = require("./dom/Div");

Object.defineProperty(exports, "Div", {
  enumerable: true,
  get: function get() {
    return Div_1.Div;
  }
});

var ScrollableContainer_1 = require("./dom/ScrollableContainer");

Object.defineProperty(exports, "ScrollableContainer", {
  enumerable: true,
  get: function get() {
    return ScrollableContainer_1.ScrollableContainer;
  }
});

var TruncatedText_1 = require("./dom/TruncatedText");

Object.defineProperty(exports, "TruncatedText", {
  enumerable: true,
  get: function get() {
    return TruncatedText_1.TruncatedText;
  }
});

var useResizeObserver_1 = require("./dom/useResizeObserver");

Object.defineProperty(exports, "useResizeObserver", {
  enumerable: true,
  get: function get() {
    return useResizeObserver_1.useResizeObserver;
  }
});

var SafeAreaView_1 = require("./dom/SafeAreaView");

Object.defineProperty(exports, "SafeAreaView", {
  enumerable: true,
  get: function get() {
    return SafeAreaView_1.SafeAreaView;
  }
});

var Avatar_1 = require("./ant/Avatar");

Object.defineProperty(exports, "Avatar", {
  enumerable: true,
  get: function get() {
    return Avatar_1.Avatar;
  }
});

var EditableText_1 = require("./ant/EditableText");

Object.defineProperty(exports, "EditableText", {
  enumerable: true,
  get: function get() {
    return EditableText_1.EditableText;
  }
});

var Player_1 = require("./player/Player");

Object.defineProperty(exports, "Player", {
  enumerable: true,
  get: function get() {
    return Player_1.Player;
  }
});

var MediaPlaybackContext_1 = require("./player/MediaPlaybackContext");

Object.defineProperty(exports, "MediaPlaybackContextProvider", {
  enumerable: true,
  get: function get() {
    return MediaPlaybackContext_1.MediaPlaybackContextProvider;
  }
});
Object.defineProperty(exports, "useMediaPlaybackContext", {
  enumerable: true,
  get: function get() {
    return MediaPlaybackContext_1.useMediaPlaybackContext;
  }
});
Object.defineProperty(exports, "MediaPlaybackContext", {
  enumerable: true,
  get: function get() {
    return MediaPlaybackContext_1.MediaPlaybackContext;
  }
});

var omitDeep_1 = require("./omitDeep");

Object.defineProperty(exports, "omitDeep", {
  enumerable: true,
  get: function get() {
    return omitDeep_1.omitDeep;
  }
});

var AntiIcon_1 = require("./AntiIcon");

Object.defineProperty(exports, "AntiIcon", {
  enumerable: true,
  get: function get() {
    return AntiIcon_1.AntiIcon;
  }
});

var HlsPlayer_1 = require("./player/HlsPlayer");

Object.defineProperty(exports, "HlsPlayer", {
  enumerable: true,
  get: function get() {
    return HlsPlayer_1.HlsPlayer;
  }
});

var useUpdatingRef_1 = require("./useUpdatingRef");

Object.defineProperty(exports, "useUpdatingRef", {
  enumerable: true,
  get: function get() {
    return useUpdatingRef_1.useUpdatingRef;
  }
});
Object.defineProperty(exports, "useUpdatingState", {
  enumerable: true,
  get: function get() {
    return useUpdatingRef_1.useUpdatingState;
  }
});

var useEffectAfterMount_1 = require("./useEffectAfterMount");

Object.defineProperty(exports, "useEffectAfterMount", {
  enumerable: true,
  get: function get() {
    return useEffectAfterMount_1.useEffectAfterMount;
  }
});

var FilterButton_1 = require("./FilterButton");

Object.defineProperty(exports, "FilterButton", {
  enumerable: true,
  get: function get() {
    return FilterButton_1.FilterButton;
  }
});
Object.defineProperty(exports, "MultiFilterButton", {
  enumerable: true,
  get: function get() {
    return FilterButton_1.MultiFilterButton;
  }
});

__exportStar(require("./oxfordComma"), exports);